export default __webpack_public_path__ + "static/media/complementary--trams--g1.3bfc644b.png";